import React from "react";
import { VscPass } from "react-icons/vsc";
import { PassWrapper } from "../styled/Pass.styled";

export default function Pass() {
  return (
    <PassWrapper>
      <VscPass />
    </PassWrapper>
  );
}
